import { render, staticRenderFns } from "./MotorProposalPremium.vue?vue&type=template&id=761f6cec&"
import script from "./MotorProposalPremium.vue?vue&type=script&lang=js&"
export * from "./MotorProposalPremium.vue?vue&type=script&lang=js&"
import style0 from "./MotorProposalPremium.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorProposalPremium.vue"
export default component.exports